// extracted by mini-css-extract-plugin
export default {"view":"Email_view__bGedS","alert":"Email_alert__KwK12","alertAfter":"Email_alertAfter__q5mT+"};